module.exports = __webpack_public_path__ + "5c8400057ff537529dc40ad622ac5dc5.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/paint-brush.png
// module id = 2414
// module chunks = 0